/* RESPONSIBLE TEAM: team-knowledge-foundations */
import type AppService from 'embercom/services/app-service';
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import KNOWLEDGE_BLANK_QUERY_PARAMS from 'embercom/lib/knowledge-hub/list-api';
import type KnowledgeHubService from 'embercom/services/knowledge-hub-service';
export const REDIRECTION_TO_KH_CONTENT_PAGE_KEY = 'redirectionToKHContentPage';

export default class KnowledgeHubIndexRoute extends Route {
  @service declare router: RouterService;
  @service declare knowledgeHubService: KnowledgeHubService;
  @service declare appService: AppService;
  @service declare helpCenterService: $TSFixMe;

  private async canRedirectToAllContent() {
    if (localStorage.getItem(REDIRECTION_TO_KH_CONTENT_PAGE_KEY) === 'true') {
      return true;
    }
    if (!this.knowledgeHubService.overviewChecklistAttributes) {
      return false;
    }
    if (
      (this.knowledgeHubService.overviewChecklistAttributes.ai_agent_enabled &&
        this.knowledgeHubService.hasAddedMinimunRequiredSources('agent')) ||
      (this.knowledgeHubService.overviewChecklistAttributes.used_ai_copilot &&
        this.knowledgeHubService.hasAddedMinimunRequiredSources('copilot')) ||
      this.helpCenterService.allLiveSites.length > 0
    ) {
      localStorage.setItem(REDIRECTION_TO_KH_CONTENT_PAGE_KEY, 'true');
      return true;
    }
    return false;
  }

  async beforeModel() {
    if (await this.canRedirectToAllContent()) {
      this.router.transitionTo('apps.app.knowledge-hub.all-content', {
        queryParams: KNOWLEDGE_BLANK_QUERY_PARAMS,
      });
    } else {
      this.router.transitionTo('apps.app.knowledge-hub.overview');
    }
  }
}
